import { WidgetTypes } from 'interfaces';
import ITrackingObject from '@/interfaces/tracking-object.interface';
import { Product, Action } from '@studyportals/datalake-event-tracker';
import {
	EventNames,
	ImpressionValidator,
} from '@studyportals/impression-validator';
import globals from './globals';
import { Ref } from 'vue';

export default class ImpressionTracker {
	private impressionValidator: ImpressionValidator;

	constructor(
		private parentElement: HTMLElement,
		private widgetType: WidgetTypes,
		private widgetLocation: string,
		private studyId: number,
		private bestfitScore: Ref<number | null>,
	) {
		this.bindImpressionEvent();

		this.impressionValidator = new ImpressionValidator(
			this.parentElement,
			'js-Widget',
		);
		this.impressionValidator.processElements();
	}

	public processElement(): void {
		this.impressionValidator.processElements();
	}

	private bindImpressionEvent(): void {
		const element = this.parentElement.querySelector('.js-Widget')!;
		element?.addEventListener(EventNames.VALIDATED_IMPRESSION, () => {
			this.trackImpression();
		});
	}

	private trackImpression(): void {
		const trackingParams: ITrackingObject = {
			category: Product.BESTFIT_OVERVIEW,
			action: Action.IMPRESSION,
			label: `widget_${this.widgetType}@${this.widgetLocation}`,
			property: String(this.studyId),
			value: this.bestfitScore.value ?? 0,
		};

		globals.bestFitTracking.snowPlow(trackingParams);
	}
}
